import React, { useEffect, useRef } from 'react';
import '../Screen.css';
import KeyboardShortcut from '../KeyboardShortcut';
import RichText from '../RichText';

function InfoScreen({ block, variables = {}, onNext }) {
  const buttons = block.buttons || [];
  const hasSingleButton = buttons.length === 1;
  const mountTimeRef = useRef(Date.now());

  useEffect(() => {
    if (!hasSingleButton) return;

    // Защита от обработки события, которое пришло во время монтирования компонента
    // (например, если Shift+Enter был нажат на предыдущем экране)
    const mountTime = Date.now();
    mountTimeRef.current = mountTime;
    const MIN_TIME_BETWEEN_MOUNT_AND_KEY = 100; // 100ms задержка

    const handleKeyDown = (e) => {
      // Игнорируем события из textarea/input (они обрабатываются в InputScreen)
      const activeElement = document.activeElement;
      if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
        return;
      }

      // Защита от обработки "старых" событий
      const timeSinceMount = Date.now() - mountTimeRef.current;
      if (timeSinceMount < MIN_TIME_BETWEEN_MOUNT_AND_KEY) {
        return;
      }

      if (e.key === 'Enter' && e.shiftKey) {
        e.preventDefault();
        const firstButton = buttons[0];
        if (firstButton && firstButton.nextId) {
          // Для info блоков value не нужен, передаем null
          onNext(null, firstButton.nextId);
        }
      }
    };

    // Добавляем обработчик с небольшой задержкой, чтобы избежать обработки "старых" событий
    const timeoutId = setTimeout(() => {
      window.addEventListener('keydown', handleKeyDown);
    }, MIN_TIME_BETWEEN_MOUNT_AND_KEY);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('keydown', handleKeyDown);
    };
    // Важно: block.id в зависимостях — иначе при переходе info→info обработчик
    // не пересоздаётся и держит nextId предыдущего экрана (Shift+Enter «зацикливает»).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [block.id, hasSingleButton, onNext]);

  const handleButtonClick = (nextId) => {
    if (nextId) {
      // Для info блоков value не нужен, передаем null
      onNext(null, nextId);
    }
  };

  return (
    <div className="screen">
      <div className="screen-content">
        <h1 className="large-text">
          <RichText text={block.text} variables={variables} />
        </h1>
        <div className={hasSingleButton ? "button-wrapper" : "choice-buttons"}>
          {buttons.map((button, index) => (
            <button
              key={index}
              className={hasSingleButton ? "button" : "button choice-button"}
              onClick={() => handleButtonClick(button.nextId)}
            >
              <span className="button-text">{button.text}</span>
              {hasSingleButton && (
                <KeyboardShortcut />
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default InfoScreen;

